import React from 'react';
import ModernNode from './ModernNode';
import { NODE_TYPES } from '../../config/nodeConfig';

const PhotoNode = (props) => {
  return <ModernNode {...props} nodeType={NODE_TYPES.PHOTO} />;
};

export default PhotoNode;